var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dorm_right2"}},[_c('div',{staticClass:"main-value leavelist"},[_c('div',{staticClass:"normal-header"},[_vm._v("请假学生名单")]),_c('dv-scroll-board',{staticClass:"table",attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }